import type { SeoMeta } from "./pageSeo";

/** Keys must match API / URL `store` after normalizeStoreKey (e.g. amazon.com, play.google.com). */
export const brandSeoMap: Record<string, SeoMeta> = {
  "amazon.com": {
    title: "Amazon Promo Codes – Up to 70% Off & Latest Deals",
    description:
      "Find the latest Amazon promo codes, coupons and deals. Save up to 70% on electronics, fashion and more with daily updated offers and discounts.",
  },
  "biggmans.com": {
    title: "Biggmans Promo Codes – Latest Deals & Discounts",
    description:
      "Discover the latest Biggmans promo codes, coupons and deals. Save on your orders with verified discounts and special offers, updated regularly.",
  },
  "dhgate.com": {
    title: "DHgate Promo Codes – Up to 80% Off Wholesale Deals",
    description:
      "Get the latest DHgate promo codes, coupons and deals. Save up to 80% on electronics, fashion and wholesale products with verified discounts and offers.",
  },
  "prana.com": {
    title: "prAna Promo Codes – Up to 40% Off Outdoor Apparel",
    description:
      "Find prAna promo codes, coupons and deals. Save up to 40% on sustainable outdoor clothing, yoga wear and active apparel with verified offers.",
  },
  "govets.com": {
    title: "Govets Promo Codes April 2026 – Industrial Supplies Deals",
    description:
      "Explore Govets promo codes, coupons and deals. Save on industrial supplies, tools and equipment with verified discounts and business offers.",
  },
  "samsung.com": {
    title: "Samsung Promo Codes with Up to 50% Off Tech Deals",
    description:
      "Discover Samsung promo codes, coupons and deals. Save up to 50% on smartphones, TVs and electronics with the latest verified offers and discounts.",
  },
  "dell.com": {
    title: "Dell Promo Codes with Up to 50% Off Laptops and PCs",
    description:
      "Find the latest Dell promo codes, coupons and deals. Save up to 50% on laptops, desktops and accessories with verified discounts and limited-time offers.",
  },
  "play.google.com": {
    title: "Google Play Promo Codes for Gift Cards and App Deals",
    description:
      "Discover Google Play promo codes, coupons and deals. Save on apps, games, movies and gift cards with the latest offers and digital discounts.",
  },
  "sephora.com": {
    title: "Sephora Promo Codes with Up to 40% Off Beauty Deals",
    description:
      "Get the latest Sephora promo codes, coupons and deals. Save up to 40% on makeup, skincare and beauty products with verified discounts and offers.",
  },
  "zlikehair.com": {
    title: "Zlikehair Promo Codes for Hair Extensions Deals and Discounts",
    description:
      "Find Zlikehair promo codes, coupons and deals. Save on human hair wigs, extensions and beauty products with verified discounts and special offers.",
  },
  "switch-bot.com": {
    title: "SwitchBot Promo Codes for Smart Home Deals and Discounts",
    description:
      "Discover SwitchBot promo codes, coupons and deals. Save on smart home devices, automation tools and accessories with verified offers and discounts.",
  },
  "tenorshare.com": {
    title: "Tenorshare Promo Codes for Software Deals and Discounts",
    description:
      "Find Tenorshare promo codes, coupons and deals. Save on data recovery, iOS tools and utility software with verified discounts and special offers.",
  },
  "bestvetcare.com": {
    title: "BestVetCare Promo Codes for Pet Care Deals and Savings",
    description:
      "Discover BestVetCare promo codes, coupons and deals. Save on pet medications, flea and tick treatments with verified discounts and offers.",
  },
  "itead.cc": {
    title: "ITEAD Promo Codes for Smart Devices and Electronics Deals",
    description:
      "Find ITEAD promo codes, coupons and deals. Save on smart home devices, IoT modules and electronics with verified discounts and offers.",
  },
  "olivenorma.com": {
    title: "Olivenorma Promo Codes with Latest Deals and Discounts",
    description:
      "Discover Olivenorma promo codes, coupons and deals. Save on your orders with verified discounts and special offers, updated regularly.",
  },
};
